// extracted by mini-css-extract-plugin
module.exports = {"separator":"Otc_separator__MaPz_","OtcContainer":"Otc_OtcContainer__8a1Dv"};